import { Card } from "antd";
import Icon from "../../../../../../assets/Icon";
import { ArrowRightIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
// import heroImg from "../../../../assets/Illustrations/prepare.svg";

const PrepareMain = ({ jobGuideIdentifier, industryId, basicGuideDetails }) => {
  const navigate = useNavigate();

  const navigateToLearn = () => {
    if (industryId) {
      navigate(
        `/org-admin/viewGuide/${jobGuideIdentifier}?industryId=${industryId}`,
      );
    } else {
      navigate(`/org-admin/viewGuide/${jobGuideIdentifier}`);
    }
  };
  const navigateToPractice = () => {
    if (industryId) {
      navigate(
        `/org-admin/practiceGuide/${jobGuideIdentifier}?industryId=${industryId}`,
      );
    } else {
      navigate(`/org-admin/practiceGuide/${jobGuideIdentifier}`);
    }
  };

  return (
    <>
      <div className="max-w-full sm:max-w-[85%] mx-auto flex flex-col justify-center items-center">
        {/* <img src={heroImg} width={380} alt="prepare-img" className="mb-2" /> */}
        <div className="text-[#0F1B23] font-semibold text-[1.4rem] text-center max-w-[48rem] break-words leading-[1.95rem]">
          Prep for{" "}
          <span className="text-[#FE7B02] font-bold">
            {basicGuideDetails?.jobTitle || "N/A"}
          </span>{" "}
          {basicGuideDetails?.companyName?.trim() && (
            <span>@{basicGuideDetails?.companyName}</span>
          )}
        </div>
        <div className="mt-[.85rem] text-[1rem] text-[#0F1B23] font-semibold text-center">
          Get Ready, Step by Step
        </div>
        <div className="text-[#475467] text-[1rem] font-medium text-center">
          Build skills, then test them in real interview-like scenarios.
        </div>
        <div className="flex flex-col sm:flex-row gap-x-5 gap-y-3 mt-[1.15rem]">
          <Card className="orange-card max-w-[380px] hover-effect cursor-pointer">
            <div className="flex flex-col gap-2">
              <div className="border-[2px] py-[.45rem] px-[.5rem] border-[#DFDFDF] flex justify-center items-center w-fit rounded-[8px]">
                <Icon type="preparation-logo" color="#101828" />
              </div>

              <div className="text-[#101828] font-semibold text-[1rem]">
                Learn with Confidence
              </div>
            </div>
            <div className="text-[#475467] font-medium text-[0.875rem]">
              Bite-sized lessons, curated prep material, and role-specific
              insights.
            </div>
            <div
              onClick={navigateToLearn}
              className="mt-[.1rem] w-fit text-amber-600 font-semibold hover:text-amber-500 transition-all duration-200 text-[0.875rem] pt-[0.36rem] flex gap-1 items-center"
            >
              Start Learning <ArrowRightIcon size={20} color="currentColor" />
            </div>
          </Card>
          <Card className="orange-card max-w-[380px] hover-effect cursor-pointer">
            <div className="flex flex-col gap-2">
              <div className="border-[2px] py-[.45rem] px-[.5rem] border-[#DFDFDF] flex justify-center items-center w-fit rounded-[8px]">
                <Icon Icon type="mock-test-logo" color="#101828" />
              </div>

              <div className="text-[#101828] font-semibold text-[1rem]">
                Practice Like It's Real
              </div>
            </div>
            <div className="text-[#475467] font-medium text-[0.875rem]">
              AI-powered practice questions and exercises to sharpen your
              skills.
            </div>
            <div
              onClick={navigateToPractice}
              className="mt-[.1rem] w-fit text-amber-600 font-semibold hover:text-amber-500 transition-all duration-200 text-[0.875rem] pt-[0.36rem] flex gap-1 items-center"
            >
              Start Practicing <ArrowRightIcon size={20} color="currentColor" />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default PrepareMain;
